<section class="content">
    <div class="content-block">
        <div class="block-header">
<p>extra-page works!</p>
</div>
</div>
</section>
